module.exports = "/_next/static/images/ScanPreview2-fd160c3986debff32b035dc2419b3fe8.png";